var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#7E84FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8592 19.3218C15.8759 19.3432 15.8972 19.3604 15.9216 19.3723C15.946 19.3842 15.9727 19.3903 15.9998 19.3903C16.0269 19.3903 16.0537 19.3842 16.078 19.3723C16.1024 19.3604 16.1237 19.3432 16.1405 19.3218L18.6405 16.1589C18.732 16.0428 18.6494 15.8709 18.4998 15.8709H16.8458V8.31737C16.8458 8.21915 16.7655 8.13879 16.6672 8.13879H15.328C15.2297 8.13879 15.1494 8.21915 15.1494 8.31737V15.8687H13.4998C13.3503 15.8687 13.2677 16.0406 13.3592 16.1567L15.8592 19.3218ZM24.1695 18.5406H22.8302C22.732 18.5406 22.6516 18.6209 22.6516 18.7192V22.1567H9.34804V18.7192C9.34804 18.6209 9.26768 18.5406 9.16947 18.5406H7.83018C7.73197 18.5406 7.65161 18.6209 7.65161 18.7192V23.1388C7.65161 23.5339 7.97081 23.8531 8.3659 23.8531H23.6338C24.0288 23.8531 24.348 23.5339 24.348 23.1388V18.7192C24.348 18.6209 24.2677 18.5406 24.1695 18.5406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.495cd4a0e1d6edb2e1b0cce93f859e77.svg";
export { ForwardRef as ReactComponent };